module.exports = __webpack_public_path__ + "img/add-member-plus-hover.3fc92e01.svg";